import Blurb from "./Blurb";
import Options from "./Options";
import Original from "./Original";
import Transformed from "./Transformed";

import { Container } from "react-bootstrap";
import { Row } from "react-bootstrap";
import { Col } from "react-bootstrap";
import React from "react";

function Aya() {
  
  return (
    <div className="main">
      <Container fluid>
        <Row>
          <Col>
            <Blurb text="Marca la casilla o casillas que quieres visualizar" />
          </Col>
        </Row>
        <br></br>
        <Options/>
        <br></br>
        <Row>
          <Col>
            <Blurb text="Escribe una frase en el primer cuadro o haz click en el botón de las flechas para generar una frase automáticamente. Después, haz click en el botón del ojo para ver la transcripción" />
          </Col>
        </Row>
        <br></br>
        <Original/>
        <Transformed/>
      </Container>
    </div>
  );
}

export default Aya;
